var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutorenew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47467 9.19616C1.26079 8.82671 1.10037 8.44755 0.993424 8.05866C0.88648 7.66977 0.833008 7.27116 0.833008 6.86283C0.833008 5.56005 1.28509 4.45171 2.18926 3.53783C3.09342 2.62394 4.1969 2.16699 5.49967 2.16699H5.60176L4.66842 1.23366L5.48509 0.416992L7.81842 2.75033L5.48509 5.08366L4.66842 4.26699L5.60176 3.33366H5.49967C4.52745 3.33366 3.70106 3.67637 3.02051 4.36178C2.33995 5.0472 1.99967 5.88088 1.99967 6.86283C1.99967 7.1156 2.02884 7.36352 2.08717 7.60658C2.14551 7.84963 2.23301 8.08783 2.34967 8.32116L1.47467 9.19616ZM5.51426 13.2503L3.18092 10.917L5.51426 8.58366L6.33092 9.40033L5.39759 10.3337H5.49967C6.4719 10.3337 7.29829 9.99095 7.97884 9.30553C8.6594 8.62012 8.99967 7.78644 8.99967 6.80449C8.99967 6.55171 8.97051 6.3038 8.91217 6.06074C8.85384 5.81769 8.76634 5.57949 8.64967 5.34616L9.52467 4.47116C9.73856 4.8406 9.89898 5.21977 10.0059 5.60866C10.1129 5.99755 10.1663 6.39616 10.1663 6.80449C10.1663 8.10727 9.71426 9.2156 8.81009 10.1295C7.90592 11.0434 6.80245 11.5003 5.49967 11.5003H5.39759L6.33092 12.4337L5.51426 13.2503Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorenew);
export default __webpack_public_path__ + "static/media/autorenew.4e09d1986d2cbefdb4dbb638adc64f0d.svg";
export { ForwardRef as ReactComponent };